import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, History, Plus, Pencil, Trash2, ArrowUpDown, Settings as SettingsIcon } from "lucide-react";
import { api, apiErr } from "@/lib/api";

const TARGET_LABEL = {
  team: "Tim", services: "Program", partners: "Mitra", stats: "Statistik",
  albums: "Galeri", settings: "Pengaturan", staff: "Akun Staf",
};

const ACTION = {
  create: { label: "menambah", icon: Plus, cls: "bg-emerald-500/15 text-emerald-400" },
  update: { label: "mengubah", icon: Pencil, cls: "bg-cyan/15 text-cyan" },
  delete: { label: "menghapus", icon: Trash2, cls: "bg-red-500/15 text-red-400" },
  reorder: { label: "menyusun ulang", icon: ArrowUpDown, cls: "bg-gold/15 text-gold" },
};

export const AuditPanel = () => {
  const [list, setList] = useState(null);

  useEffect(() => {
    api.get("/admin/audit").then((r) => setList(r.data)).catch((e) => {
      toast.error(apiErr(e));
      setList([]);
    });
  }, []);

  const fmt = (iso) => {
    try {
      return new Date(iso).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "short" });
    } catch {
      return iso;
    }
  };

  if (list === null)
    return (
      <div className="py-20 grid place-items-center">
        <Loader2 className="w-6 h-6 animate-spin text-cyan" />
      </div>
    );

  return (
    <div data-testid="panel-audit">
      <h2 className="font-heading font-bold text-2xl mb-1">Riwayat Perubahan</h2>
      <p className="text-sm text-slate-500 mb-6">Catatan siapa mengubah konten apa dan kapan.</p>

      {list.length === 0 ? (
        <div className="py-20 grid place-items-center text-slate-500">
          <History className="w-10 h-10 mb-3" />
          <p>Belum ada aktivitas tercatat.</p>
        </div>
      ) : (
        <div className="relative pl-4">
          <div className="absolute left-[7px] top-2 bottom-2 w-px bg-white/10" />
          <div className="space-y-3">
            {list.map((a) => {
              const act = ACTION[a.action] || { label: a.action, icon: SettingsIcon, cls: "bg-white/10 text-slate-300" };
              const Icon = act.icon;
              const target = TARGET_LABEL[a.target] || a.target;
              return (
                <div key={a.id} data-testid="audit-row" className="relative flex items-center gap-4 rounded-xl border border-white/10 bg-navy-card/50 px-4 py-3">
                  <span className={`grid place-items-center w-9 h-9 rounded-lg shrink-0 ${act.cls}`}>
                    <Icon className="w-4 h-4" />
                  </span>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm text-slate-200">
                      <span className="font-semibold">{a.user_name || a.user_email}</span>{" "}
                      <span className="text-slate-400">{act.label}</span>{" "}
                      <span className="font-medium text-white">{target}</span>
                      {a.label && <span className="text-slate-400"> — “{a.label}”</span>}
                    </p>
                    <p className="text-xs text-slate-500 mt-0.5">{a.user_email}</p>
                  </div>
                  <span className="text-xs text-slate-500 shrink-0 whitespace-nowrap">{fmt(a.created_at)}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};
